<template>
	<div class="nk-stabs d-flex flex-column">
		<div class="nk-stabs-header-bar" ref="tabsHeaderBar">
			<!-- Scroller Right Button (toward start in RTL) -->
			<button
				v-show="canScrollRight"
				type="button"
				class="nk-tab-scroll-btn nk-stabs-scroll-btn scroll-right"
				@click="scrollTabs('right')"
				:title="$t ? $t('nav.tabs.scroll-right') : 'اسکرول به راست'"
				tabindex="-1"
			>
				<i class="fal fa-chevron-right"></i>
			</button>

			<!-- Scrollable Tabs List -->
			<div
				class="nk-stabs-scroll-container"
				ref="tabsScrollContainer"
				@scroll="onTabsScroll"
				@wheel="onTabsWheel"
			>
				<ul
					class="nav nav-tabs"
					tabscope
					:tabindex="tabindex"
					ref="tabul"
					:startup="startup ? true : null"
					@focus="onFocus"
				>
					<li
						v-for="(tab, i) in tabs"
						:key="tab.id"
						:data-tab-id="tab.id"
						class="nav-item"
						:tabindex="i + 1"
					>
						<a v-if="tab.closable" @click="closeTab(tab.id)" class="nav-close"><i class="fal fa-times"></i></a>
						<a
							@click="selectTab(tab.id, $event)"
							class="nav-link"
							:class="{ 'active': tab.isActive, 'disabled': tab.isDisabled }"
							v-html="tab.name"
							href="javascript:void(0)"
						></a>
					</li>
				</ul>
			</div>

			<!-- Scroller Left Button (toward end in RTL) -->
			<button
				v-show="canScrollLeft"
				type="button"
				class="nk-tab-scroll-btn nk-stabs-scroll-btn scroll-left"
				@click="scrollTabs('left')"
				:title="$t ? $t('nav.tabs.scroll-left') : 'اسکرول به چپ'"
				tabindex="-1"
			>
				<i class="fal fa-chevron-left"></i>
			</button>
		</div>

		<div :class="{ 'nk-stabs-panels': true, 'scrollable': scrollable }" ref="tabs-panel">
			<slot />
		</div>
	</div>
</template>
<script>
	import $ from 'jquery'

	export default {
		name: 'stab-host',
		props: {
			tabKeys: { type: Array, default: [] },
			activeTab: { default: '' },
			tabindex: { type: Number, default: () => 1 },
			scrollable: { type: Boolean, default: false },
			startup: { type: Boolean }
		},
		emits: ['activeTabChanged', 'closeClicked'],
		data() {
			return {
				tabs: [],
				currentTab: null,
				canScrollLeft: false,
				canScrollRight: false,
				resizeObserver: null,
				scrollRaf: null
			}
		},
		watch: {
			tabs: {
				deep: true,
				handler(value, oldValue) {
					this.defer(this.subscribeKeys, 1)
					this.$nextTick(() => {
						this.updateScrollButtons()
					})
				}
			},
			activeTab: {
				handler(value, oldValue) {
					if (value != this.currentTab)
						this.selectTab(value)
				}
			},
			tabKeys: {
				handler(value, oldValue) {
					this.tabs = this.tabs.filter(t => (value || []).indexOf(t.id) > -1)
					if (value.length && value.indexOf(this.activeTab) === -1) {
						this.$nextTick(() => {
							this.selectTab(value[value.length - 1])
						})
					}
					this.$nextTick(() => {
						this.updateScrollButtons()
					})
				}
			}
		},
		computed: {
		},
		created() {
		},
		mounted() {
			if (this.tabs.length > 0) {
				if (this.activeTab !== '') {
					this.selectTab(this.activeTab)
				} else {
					this.selectTab(this.tabs[0].id)
				}
			}
			this.initScrollObserver()
		},
		beforeUnmount() {
			if (this.scrollRaf) {
				cancelAnimationFrame(this.scrollRaf)
			}
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
				this.resizeObserver = null
			}
			if (this.onResize) {
				window.removeEventListener('resize', this.onResize)
			}
		},
		methods: {
			initScrollObserver() {
				this.onResize = () => this.updateScrollButtons()
				window.addEventListener('resize', this.onResize)

				if (window.ResizeObserver && this.$refs.tabsScrollContainer) {
					this.resizeObserver = new ResizeObserver(() => {
						this.updateScrollButtons()
					})
					this.resizeObserver.observe(this.$refs.tabsScrollContainer)
					if (this.$refs.tabul) {
						this.resizeObserver.observe(this.$refs.tabul)
					}
				}

				this.$nextTick(() => {
					this.updateScrollButtons()
				})
			},

			onTabsScroll() {
				this.updateScrollButtons()
			},

			onTabsWheel(event) {
				const el = this.$refs.tabsScrollContainer
				if (!el) return

				if (el.scrollWidth > el.clientWidth) {
					event.preventDefault()
					const delta = event.deltaY || event.deltaX
					const isRtl = window.getComputedStyle(el).direction === 'rtl'
					if (isRtl) {
						el.scrollLeft -= delta
					} else {
						el.scrollLeft += delta
					}
					this.updateScrollButtons()
				}
			},

			updateScrollButtons() {
				if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf)
				this.scrollRaf = requestAnimationFrame(() => {
					const el = this.$refs.tabsScrollContainer
					if (!el) {
						this.canScrollLeft = false
						this.canScrollRight = false
						return
					}

					const scrollLeft = Math.abs(el.scrollLeft)
					const scrollWidth = el.scrollWidth
					const clientWidth = el.clientWidth
					const maxScroll = Math.max(0, scrollWidth - clientWidth)

					if (maxScroll <= 2) {
						this.canScrollLeft = false
						this.canScrollRight = false
						return
					}

					const isRtl = window.getComputedStyle(el).direction === 'rtl'
					if (isRtl) {
						this.canScrollRight = scrollLeft > 2
						this.canScrollLeft = scrollLeft < maxScroll - 2
					} else {
						this.canScrollLeft = el.scrollLeft > 2
						this.canScrollRight = el.scrollLeft < maxScroll - 2
					}
				})
			},

			scrollTabs(direction) {
				const el = this.$refs.tabsScrollContainer
				if (!el) return

				const offset = direction === 'left' ? -200 : 200
				if (typeof el.scrollBy === 'function') {
					el.scrollBy({ left: offset, behavior: 'smooth' })
				} else {
					el.scrollLeft += offset
				}
				setTimeout(() => {
					this.updateScrollButtons()
				}, 220)
			},

			scrollToTab(id) {
				this.$nextTick(() => {
					const container = this.$refs.tabsScrollContainer
					if (!container) return
					const targetTab = this.findTab(id)
					if (!targetTab) return

					const tabElements = container.querySelectorAll('[data-tab-id]')
					for (let i = 0; i < tabElements.length; i++) {
						if (tabElements[i].getAttribute('data-tab-id') === String(targetTab.id)) {
							if (typeof tabElements[i].scrollIntoView === 'function') {
								tabElements[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
							}
							break
						}
					}
					setTimeout(() => {
						this.updateScrollButtons()
					}, 220)
				})
			},

			onFocus() {
				// this.focusTab()
			},

			findTab(id) {
				return this.tabs.find(tab => tab.id === id)
			},
			closeTab(tabId) {
				this.$emit('closeClicked', tabId)
			},
			selectTab(selectedTabId, event) {
				if (typeof event !== 'undefined') {
					event.preventDefault()
				}

				const selectedTab = this.findTab(selectedTabId)

				if (!selectedTab) {
					return
				}

				if (selectedTab.isDisabled) {
					return
				}

				this.tabs.forEach(tab => {
					tab.isActive = (tab.id === selectedTab.id)
				})

				this.currentTab = selectedTab.id
				this.$emit('activeTabChanged', selectedTab.id)

				this.scrollToTab(selectedTab.id)

				// if event != undefined then this called by an click or keydown event
				if (typeof event !== 'undefined') {
					this.focusTab()
				}
			},
			setTabVisible(id, visible) {
				const tab = this.findTab(id)

				if (!tab) {
					return
				}

				tab.isVisible = visible

				if (tab.isActive) {
					// If tab is active, set a different one as active.
					tab.isActive = visible

					this.tabs.every((tab, index, array) => {
						if (tab.isVisible) {
							tab.isActive = true

							return false
						}

						return true
					})
				}
			},
			focusTab() {
				var that = this
				setTimeout(() => {
					var tabItems = $(that.$refs['tabs-panel']).find('section:visible [tabindex]').map(function (index, item) {
						return {
							tabindex: parseInt(item.attributes.tabindex.value),
							el: item
						}
					})

					if (tabItems.length > 0) {
						var min = tabItems[0]

						for (var i = 1; i < tabItems.length; i++) {
							if (tabItems[i].tabindex > 0 && tabItems[i].tabindex < min.tabindex) {
								min.el = tabItems[i].el
							}
						}

						if (min.el != null) {
							$(min.el).focus()
						}
					}
				}, 5)
			},
			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: `stab-open-tab`,
					keyCode: 32, // 32:space
					el: $(this.$refs.tabul).find('> li.nav-item'),
					context: this,
					handler: function (sender, e) {
						e.preventDefault()

						var index = $(this.$refs.tabul).find('> li.nav-item').index(sender)
						if (index > -1) {
							e.preventDefault()

							var tab = this.tabs[index]
							this.selectTab(tab.id, e)
						}
					}
				})
			}
		}
	}
</script>
<style lang="less">
	.nk-stabs {
		.nk-stabs-header-bar {
			display: flex;
			align-items: center;
			position: relative;
			border-bottom: 1px solid #dee2e6;
			gap: 4px;
			user-select: none;

			[dir="ltr"] &,
			&[dir="ltr"] {
				.scroll-left {
					order: 1;
				}
				.nk-stabs-scroll-container {
					order: 2;
				}
				.scroll-right {
					order: 3;
				}
			}
		}

		.nk-stabs-scroll-btn {
			margin-bottom: 2px;
			z-index: 2;

			&:disabled,
			&.disabled {
				opacity: 0.35;
				cursor: not-allowed;
				pointer-events: none;
			}
		}

		.nk-stabs-scroll-container {
			flex: 1 1 0%;
			min-width: 0 !important;
			width: 0;
			overflow-x: auto !important;
			overflow-y: hidden !important;
			white-space: nowrap !important;
			margin-bottom: -1px;
			scrollbar-width: none;
			-ms-overflow-style: none;

			&::-webkit-scrollbar {
				display: none;
				width: 0;
				height: 0;
			}
		}

		.nav-tabs {
			padding-right: 0;
			display: flex;
			flex-wrap: nowrap !important;
			white-space: nowrap !important;
			border-bottom: 1px solid #dee2e6;
			margin-bottom: 0;
			min-width: 100%;
			width: max-content;

			.nav-close {
				cursor: pointer;
				position: absolute;
				left: 3px;
			}

			.nav-item {
				position: relative;
				flex-shrink: 0 !important;
				white-space: nowrap !important;
			}
		}
	}

	.nk-stabs-panels {
		padding: 10px;
		border-top: none;
	}

	.tabs-no-padding .nk-stabs-panels {
		padding: 0 !important;
	}
</style>
